<template>
  <div class="date-picker-root" :style="getRootStyle">
    <div class="form-label label-text" v-if="label">
      {{ $t(label) }}
      <span v-if="is_required" class="req-sign">*</span>
    </div>
    <validation-provider
      :name="name"
      :rules="rules"
      v-slot="{ errors }"
      :id="id"
    >
      <input type="text" v-model="inputfield" class="d-none" />
      <div class="d-flex align-items-center flex-wrap">
        <div style="margin-right: 0.5rem">
          <div
            class="select disabled"
            :style="cus_style"
            v-if="disabled || readOnly"
          >
            {{ selected_day?.text || $t("day") }}
          </div>
          <b-form-select
            v-else
            :class="[
              'select',
              {
                'invalid-select':
                  (is_invalid || (errors && errors.length)) &&
                  selected_day === null
                    ? true
                    : false,
              },
            ]"
            :label="label"
            :disabled="disabled ? true : false"
            :placeholder="placeholder"
            v-model="selected_day"
            :style="cus_style"
            :readonly="readOnly"
            :ref="cus_ref"
            :options="day_options"
            id="day"
          />
        </div>
        <div style="margin-right: 0.5rem">
          <div
            class="select disabled"
            :style="cus_style"
            v-if="disabled || readOnly"
          >
            {{ selected_month?.text || $t("month") }}
          </div>
          <b-form-select
            v-else
            :class="[
              'select',
              {
                'invalid-select':
                  (is_invalid || (errors && errors.length)) &&
                  selected_month === null
                    ? true
                    : false,
              },
            ]"
            :label="label"
            :disabled="disabled ? true : false"
            :placeholder="placeholder"
            v-model="selected_month"
            :style="cus_style"
            :readonly="readOnly"
            :ref="cus_ref"
            :options="month_options"
            id="month"
          />
        </div>
        <div style="margin-right: 0.5rem">
          <div
            class="select disabled"
            :style="cus_style"
            v-if="disabled || readOnly"
          >
            {{ selected_year?.text || $t("year") }}
          </div>
          <b-form-select
            v-else
            :class="[
              'select',
              {
                'invalid-select':
                  (is_invalid || (errors && errors.length)) &&
                  selected_year === null
                    ? true
                    : false,
              },
            ]"
            :label="label"
            :disabled="disabled ? true : false"
            :placeholder="placeholder"
            v-model="selected_year"
            :style="cus_style"
            :readonly="readOnly"
            :ref="cus_ref"
            :options="year_options"
            id="year"
          />
        </div>
      </div>
      <div v-if="helper_text" class="helper-text" :style="helper_text_style">
        {{ $t(helper_text) }}
      </div>
      <div
        class="error-text"
        :style="helper_text_style"
        v-if="errors && errors.length"
      >
        {{ errors[0] }}
      </div>
      <slot name="attachment"></slot>
    </validation-provider>
  </div>
</template>

<script>
import moment from "moment-hijri";

const monthNames = [
  "Muharram",
  "Safar",
  "Rabi Al-Awwal",
  "Rabi Al-Akhar",
  "Jumada Al-Awwal",
  "Jumada Al-Akhirah",
  "Rajab",
  "Sha'ban",
  "Ramadan",
  "Shawwal",
  "Dhu Al-Qi'dah",
  "Dhu Al-Hijjah",
];

export default {
  emits: ["change-value"],
  props: [
    "label",
    "placeholder",
    "is_invalid",
    "helper_text",
    "helper_text_style",
    "field",
    "value",
    "cus_style",
    "remove_default_margin",
    "readOnly",
    "disabled",
    "cus_ref",
    "is_required",
    "options",
    "rules",
    "name",
    "id",
  ],
  data() {
    return {
      day_options: [],
      month_options: [],
      year_options: [],
      selected_day:
        this.value && typeof this.value == "sting"
          ? this.value.split("-")[2]
          : this.value && typeof this.value == "object"
          ? this.value.day
          : null,
      selected_month:
        this.value && typeof this.value == "sting"
          ? this.value.split("-")[1]
          : this.value && typeof this.value == "object"
          ? this.value.month
          : null,
      selected_year:
        this.value && typeof this.value == "sting"
          ? this.value.split("-")[0]
          : this.value && typeof this.value == "object"
          ? this.value.year
          : null,
      inputfield: this.value,
    };
  },
  computed: {
    getRootStyle() {
      return `margin-bottom: ${
        this.remove_default_margin ? "0px" : "20px"
      };position:relative;`;
    },
  },
  methods: {
    setVal() {
      if (
        this.selected_day !== null &&
        this.selected_month !== null &&
        this.selected_year !== null
      )
        this.inputfield = {
          day: this.selected_day,
          month: this.selected_month,
          year: this.selected_year,
        };
      else this.inputfield = null;
    },
    setDaysOptions() {
      let days =
        moment(
          new Date(
            this.selected_year || 0,
            this.selected_month || 0,
            0,
            12
          ).getDate()
        )._i - 1;
      if (this.selected_month == 4) {
        days = 30;
      }

      let arr = [{ value: null, text: this.$t("day") }];
      for (let i = 1; i <= days; i++) {
        arr.push({ value: i, text: i });
      }
      this.day_options = arr;

      if (this.selected_day && this.selected_day > days)
        this.selected_day = null;
    },
    setMonthsOptions() {
      let mon = moment(new Date()).iMonth();
      let arr = [{ value: null, text: this.$t("month") }];
      for (let i = 0; i < monthNames.length; i++) {
        arr.push({ value: i + 1, text: this.$t(monthNames[i]) });
      }
      this.month_options = arr;
    },
    setYearsOptions() {
      let cur_yr = moment(new Date()).iYear(),
        arr = [{ value: null, text: this.$t("year") }];
        cur_yr = cur_yr - 2;
      for (let i = 0; i < 20; i++) {
        arr.push({ value: cur_yr + i, text: cur_yr + i });
      }

      this.year_options = arr;
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.selected_day = null;
        this.selected_month = null;
        this.selected_year = null;
        return;
      }
      if (typeof val == "object" && val != null) {
        return;
      }

      const [year, month, day] = val.split("-");

      // if (this.selected_day === null)
      this.selected_day = val ? day : null;
      // if (this.selected_month === null)
      this.selected_month = val ? month : null;
      // if (this.selected_year === null)
      this.selected_year = val ? year : null;
      if (this.inputfield === null) this.inputfield = val;
    },

    inputfield(val) {
      if (!this.inputfield) {
        this.selected_day = null;
        this.selected_month = null;
        this.selected_year = null;
        this.$emit("change-value", "reset", this.field);
      } else {
        this.$emit("change-value", this.inputfield, this.field);
      }
    },
    selected_day(val) {
      this.setVal();
    },
    selected_month(val) {
      this.setVal();
      if (val !== null) {
        this.setDaysOptions();
      }
    },
    selected_year(val) {
      this.setVal();
      if (val !== null) {
        this.setDaysOptions();
      }
    },
  },
  mounted() {
    this.setDaysOptions();
    this.setMonthsOptions();
    this.setYearsOptions();
  },
};
</script>

<style lang="scss" scoped>
.invalid-select {
  border-color: var(--color-47) !important;
  background-color: var(--color-01) !important;
}
.select {
  width: 100%;
  height: 40px;
  font-size: 14px;
  padding: 10px;
  background: var(--color-01);
  color: var(--color-61);
  border: 1px solid;
  border-radius: 6px;
  border-color: var(--color-64);
  box-shadow: 0px 1px 2px var(--color-37);
  font-weight: 400;

  &:focus-visible {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:hover {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:focus {
    border-color: var(--color-04);
    outline: none;
    box-shadow: none;
  }
  &:disabled {
    background-color: var(--color-67);
  }
}
.row > * {
  padding-right: 0px;
}
</style>
